/**
 * KOVIX-2448 (BR-18.22) — tên vai trò hiển thị thay mã. Nguồn ưu tiên: `permissions.roleNames` (iam `/me/permissions`, tên vai trò CỦA CHÍNH người dùng,
 * không cần `admin.role.view`) → danh sách `/roles` (khi có quyền) → mã làm gọn ("sales_manager" → "sales manager").
 */
export function resolveRoleNames(
  codes: readonly string[],
  known: Readonly<Record<string, string>> | undefined,
  roles: readonly { code?: string | undefined; name: string }[] | undefined,
): string[] {
  return codes.map((c) => known?.[c] ?? roles?.find((r) => r.code === c)?.name ?? c.replace(/[_.-]+/g, ' '));
}

/** Còn mã chưa có tên từ `/me/permissions` → mới cần tải `/roles`. */
export function needsRoleCatalog(
  codes: readonly string[],
  known: Readonly<Record<string, string>> | undefined,
): boolean {
  return codes.some((c) => !known?.[c]);
}
